import { ACTION_TYPES } from '../Constants';

export const setLanguage = language => ({
  type: ACTION_TYPES.LANGUAGE_CHANGED, language,
});



// WEBPACK FOOTER //
// ./src/Actions/LanguageActions.js